import { type PaymentBreakdown } from '../../types/PaymentBreakdown';
import { type ShippingMethod, type ShippingContact } from '../../types/Shipping';
import { getLocalizeBreakdownLabel } from '../../utils/i18n/paymentBreakdown';
import { type BillingContact } from '../../types/BillingContact';

export function transformPaymentBreakdownToApplePay(paymentBreakdown: PaymentBreakdown): ApplePayJS.ApplePayLineItem[] {
  return (
    paymentBreakdown &&
    Object.entries(paymentBreakdown).map((breakdownEntry: [keyof PaymentBreakdown, string]) =>
      applePayLineItemBuilder(breakdownEntry[0], breakdownEntry[1]),
    )
  );
}

export function transformShippingMethodToCommon(shippingMethod: ApplePayJS.ApplePayShippingMethod): ShippingMethod {
  return shippingMethod;
}

export const getRestrictedContact = (
  contact: ApplePayJS.ApplePayPaymentContact,
): {
  countryCode: string;
  city: string;
  state: string;
  postalCode: string;
} => {
  return {
    countryCode: contact.countryCode?.toUpperCase(),
    state: contact.administrativeArea,
    city: contact.locality,
    postalCode: contact.postalCode,
  };
};

export const getBillingContact = (
  billing: ApplePayJS.ApplePayPaymentContact,
  shipping: ApplePayJS.ApplePayPaymentContact,
): BillingContact => {
  return {
    countryCode: billing.countryCode?.toUpperCase(),
    email: shipping.emailAddress,
    phone: billing.phoneNumber,
    firstName: billing.givenName,
    lastName: billing.familyName,
  };
};

export const getShippingContact = (shipping: ApplePayJS.ApplePayPaymentContact): ShippingContact => {
  return {
    firstName: shipping.givenName,
    lastName: shipping.familyName,
    countryCode: shipping.countryCode?.toUpperCase(),
    phone: shipping.phoneNumber,
    postalCode: shipping.postalCode,
    state: shipping.administrativeArea,
    city: shipping.locality,
    addressLine1: Array.isArray(shipping.addressLines) && shipping.addressLines[0],
    addressLine2: Array.isArray(shipping.addressLines) && shipping.addressLines[1],
  };
};

function applePayLineItemBuilder(type: keyof PaymentBreakdown, value: string): ApplePayJS.ApplePayLineItem {
  const label = getLocalizeBreakdownLabel(type);
  const amount = type === 'discount' ? `-${value}` : value;
  return {
    label,
    amount,
  };
}
